import type {ReduxStore} from 'src/reducers';
import IndexStore from 'src/stores';

import * as React from 'react';
import App from './app';
import AppRoutes from 'src/reroutes/app';

import {AskAI} from 'src/components/agentic-ui';


export default function SenseApp(props: {
  reduxStore: ReduxStore;
  senseStore: IndexStore;
}) {
  const askAiEnabled = props.reduxStore.getState().agency.config.graceEnabled;

  return (
    <App {...props}>
      <AppRoutes {...props} />
      {/* NOTE:(diwakersurya) show AskAI only if the user is authed */}
      {props.senseStore.me.isAuthed() && askAiEnabled && <AskAI />}
    </App>
  );
}
